import { render, staticRenderFns } from "./comp_AppBar-LinkButton.vue?vue&type=template&id=0265e8a3&"
import script from "./comp_AppBar-LinkButton.vue?vue&type=script&lang=js&"
export * from "./comp_AppBar-LinkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports